module.exports = __webpack_public_path__ + "static/media/checklist.168677f0.jpg";